import React from 'react';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

// const ListaCF = ({list, argsDocum, permiteUpdate, handleChange}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="comoAsigCicloFact" id="miLista" value={permiteUpdate?argsDocum.comoAsigCicloFact:list.comoAsigCicloFact} onChange={(ev)=>handleChange(ev, argsDocum)}>
//         <option>Asignarlo al crear o modificar clientes</option>
//         <option>Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa</option>
//       </select>
//     </div>
//   )
// };


const ListaCS = ({list, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="contratoSequence" id="miListaCS" value={permiteUpdate?argsDocum.contratoSequence:list.contratoSequence} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

const ListaRC = ({list, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="impRboCaja" id="miLista4" value={permiteUpdate?argsDocum.impRboCaja:list.impRboCaja} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Tamaño carta</option>
        <option>Impresora pequeña 8 cm</option>
      </select>
    </div>
  )
};

const ListaPagoApp = ({list, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="enPagoApp" id="miListaApp" value={permiteUpdate?argsDocum.enPagoApp:list.enPagoApp} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Enviar mensaje por WhatsApp</option>
        <option>Generar pdf con Recibo de caja</option>
      </select>
    </div>
  )
};

// const ListaCC = ({list, argsDocum, permiteUpdate, handleChange}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="comoAsigCargosAlCliente" id="miLista1" value={permiteUpdate?argsDocum.comoAsigCargosAlCliente:list.comoAsigCargosAlCliente} onChange={(ev)=>handleChange(ev, argsDocum)}>
//         {/* <option>Hacer los cargos al cliente al cerrar las Ordenes de Servicio</option> */}
//         <option>Hacer los cargos al cliente en el proceso de facturación</option>
//       </select>
//     </div>
//   )
// };

class VerParam2 extends React.Component {
  state={
    argsDocum: {contratoSequence: this.props.list.contratoSequence?this.props.list.contratoSequence:"",
                mensaje: this.props.list.mensaje?this.props.list.mensaje:"",
                nuevoNumeroOS: this.props.list.nuevoNumeroOS?this.props.list.nuevoNumeroOS:1,
                nuevoNumeroRC: this.props.list.nuevoNumeroRC?this.props.list.nuevoNumeroRC:1,
                nuevoNumeroND: this.props.list.nuevoNumeroND?this.props.list.nuevoNumeroND:1,
                nuevoNumeroNC: this.props.list.nuevoNumeroNC?this.props.list.nuevoNumeroNC:1,
                nuevoNumeroAj: this.props.list.nuevoNumeroAj?this.props.list.nuevoNumeroAj:1,
                ajCero: this.props.list.ajCero?this.props.list.ajCero:0,
                nuevoNumeroDX: this.props.list.nuevoNumeroDX?this.props.list.nuevoNumeroDX:1,
                prefijoFact: this.props.list.prefijoFact?this.props.list.prefijoFact:"",
                comoAsigCicloFact: this.props.list.comoAsigCicloFact?this.props.list.comoAsigCicloFact:"",
                impRboCaja: this.props.list.impRboCaja?this.props.list.impRboCaja:"",
                enPagoApp: this.props.list.enPagoApp?this.props.list.enPagoApp:"",
                comoAsigCargosAlCliente: this.props.list.comoAsigCargosAlCliente?this.props.list.comoAsigCargosAlCliente:"",
                empresaRazonSocial: this.props.list.empresaRazonSocial?this.props.list.empresaRazonSocial:"",
                empresaNit: this.props.list.empresaNit?this.props.list.empresaNit:"",
                empresaDir: this.props.list.empresaDir?this.props.list.empresaDir:"",
                empresaTel: this.props.list.empresaTel?this.props.list.empresaTel:"",
                codBarrasRdo: this.props.list.codBarrasRdo?this.props.list.codBarrasRdo:"",
                pagueHastaSegunSaldo: this.props.list.pagueHastaSegunSaldo?this.props.list.pagueHastaSegunSaldo:false,
                numMesesParaPH: this.props.list.numMesesParaPH?this.props.list.numMesesParaPH:9,
                _id: this.props.list._id?this.props.list._id:"",
                checkNuevoNumeroOS: false, checkNuevoNumeroRC: false,
                checkNuevoNumeroND: false, checkNuevoNumeroNC: false, checkNuevoNumeroAj: false},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    // console.log(this.props.permiteUpdate)
    // console.log(ev.target.name)
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "checkNuevoNumeroOS"&&ev.target.name !== "checkNuevoNumeroRC"&&
          ev.target.name !== "checkNuevoNumeroND"&&ev.target.name !== "checkNuevoNumeroNC"&&
          ev.target.name !== "checkNuevoNumeroAj"&&ev.target.name !== "pagueHastaSegunSaldo"){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value 
        this.setState({argsDocum});
      }
      if(ev.target.name === "checkNuevoNumeroOS"||ev.target.name === "checkNuevoNumeroRC"||
          ev.target.name === "checkNuevoNumeroND"||ev.target.name === "checkNuevoNumeroNC"||
          ev.target.name === "checkNuevoNumeroAj"||ev.target.name === "pagueHastaSegunSaldo"){
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.checked
        this.setState({argsDocum});
      }
      if(ev.target.name === "comoAsigCicloFact"){
        const argsDocum = this.state.argsDocum
        let miLista = document.getElementById("miLista");
        argsDocum['comoAsigCicloFact'] = miLista.options[miLista.selectedIndex].text
      }
      if(ev.target.name === "contratoSequence"){
        const argsDocum = this.state.argsDocum
        let miLista = document.getElementById("miListaCS");
        argsDocum['contratoSequence'] = miLista.options[miLista.selectedIndex].text
      }
      if(ev.target.name === "impRboCaja"){
        const argsDocum = this.state.argsDocum
        let miLista = document.getElementById("miLista4");
        argsDocum['impRboCaja'] = miLista.options[miLista.selectedIndex].text
      }
      if(ev.target.name === "enPagoApp"){
        const argsDocum = this.state.argsDocum
        let miLista = document.getElementById("miListaApp");
        argsDocum['enPagoApp'] = miLista.options[miLista.selectedIndex].text
      }
      if(ev.target.name === "comoAsigCargosAlCliente"){
        const argsDocum = this.state.argsDocum
        let miLista = document.getElementById("miLista1");
        argsDocum['comoAsigCargosAlCliente'] = miLista.options[miLista.selectedIndex].text
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.list !== prevProps.list) {
  //     console.log("entroooo")
  //     this.setState({pagueHastaSegunSaldo: this.props.list.pagueHastaSegunSaldo?this.props.list.pagueHastaSegunSaldo:false});
  //   }
  // }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    // console.log(argsDocum)
    // console.log(this.props.list)
    // console.log(this.props.permiteUpdate)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Parametros
        </button>

        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <h1 style={{color: 'yellow'}}>Generales</h1>

            <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Crear contrato con consecutivo</label>
                  <ListaCS list={this.props.list} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field>

            <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Mensaje</label>
                  <input style={this.props.styles.input} autoComplete="off" name="mensaje" id="mensaje" value={this.props.permiteUpdate?argsDocum.mensaje:this.props.list.mensaje} onChange={this.handleChange} placeholder='Mensaje'/>
                </div>
              </div>
            </Form.Field>

            {/* <hr></hr> */}

            {/* <Form.Field>
              <div className="ui three column stackable grid">
                <div className="column" style={{width: '33%'}}>
                  <input type='checkbox' name="checkNuevoNumeroOS" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.checkNuevoNumeroOS:false} onChange={this.handleChange}/>

                  <label style={this.props.styles.label}>&nbsp;Reiniciar O de S con el #:</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="nuevoNumeroOS" id="nuevoNumeroOS" placeholder='# de meses' value={this.props.permiteUpdate?argsDocum.nuevoNumeroOS:this.props.list.nuevoNumeroOS} onChange={this.handleChange}/>
                </div>
                <div className="column" style={{width: '33%'}}>
                  <input type='checkbox' name="checkNuevoNumeroRC" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.checkNuevoNumeroRC:false} onChange={this.handleChange}/>

                  <label style={this.props.styles.label}>&nbsp;Reiniciar recibos de caja con el #:</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="nuevoNumeroRC" id="nuevoNumeroRC" placeholder='# de recibo de caja' value={this.props.permiteUpdate?argsDocum.nuevoNumeroRC:this.props.list.nuevoNumeroRC} onChange={this.handleChange}/>
                </div>
                <div className="column" style={{width: '34%'}}>
                  <input type='checkbox' name="checkNuevoNumeroND" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.checkNuevoNumeroND:false} onChange={this.handleChange}/>

                  <label style={this.props.styles.label}>&nbsp;Reiniciar notas débito con el #:</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="nuevoNumeroND" id="nuevoNumeroND" placeholder='# de nota débito' value={this.props.permiteUpdate?argsDocum.nuevoNumeroND:this.props.list.nuevoNumeroND?this.props.list.nuevoNumeroND:1} onChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field> */}
            {/* <Form.Field>
              <div className="ui three column stackable grid">
                <div className="column" style={{width: '33%'}}>
                  <input type='checkbox' name="checkNuevoNumeroNC" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.checkNuevoNumeroNC:false} onChange={this.handleChange}/>

                  <label style={this.props.styles.label}>&nbsp;Reiniciar notas crédito con el #:</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="nuevoNumeroNC" id="nuevoNumeroNC" placeholder='# de nota crédito' value={this.props.permiteUpdate?argsDocum.nuevoNumeroNC:this.props.list.nuevoNumeroNC?this.props.list.nuevoNumeroNC:1} onChange={this.handleChange}/>
                </div>
                <div className="column" style={{width: '33%'}}>
                  <input type='checkbox' name="checkNuevoNumeroAj" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.checkNuevoNumeroAj:false} onChange={this.handleChange}/>

                  <label style={this.props.styles.label}>&nbsp;Reiniciar ajustes con el #:</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="nuevoNumeroAj" id="nuevoNumeroAj" placeholder='# de ajuste' value={this.props.permiteUpdate?argsDocum.nuevoNumeroAj:this.props.list.nuevoNumeroAj?this.props.list.nuevoNumeroAj:1} onChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field> */}

            <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Al recibir pago si queda con saldo entre -$XXX y $XXX, hacer ajuste para dejar en saldo CERO</label>
                  <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="ajCero" id="ajCero" placeholder='Valor' value={this.props.permiteUpdate?argsDocum.ajCero:this.props.list.ajCero?this.props.list.ajCero:0} onChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field>

            <hr></hr>
            <h1 style={{color: 'yellow'}}>Facturación y pagos</h1>

            <Form.Field>
              <div className="ui two column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>En página web - Imprimir recibos de caja</label>
                  <ListaRC styles={this.props.styles} list={this.props.list} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </div>
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>En App - Al recibir el pago</label>
                  <ListaPagoApp styles={this.props.styles} list={this.props.list} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field>

            <Form.Field>
              <div className="ui two column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Código de barras</label>
                  <input style={this.props.styles.input} autoComplete="off" name="codBarrasRdo" id="codBarrasRdo" value={this.props.permiteUpdate?argsDocum.codBarrasRdo:this.props.list.codBarrasRdo?this.props.list.codBarrasRdo:""} onChange={this.handleChange} placeholder='Código de barras'/>
                </div>
                <div className="column" style={{width: '50%'}}>
                  <input type='checkbox' name="pagueHastaSegunSaldo" style={this.props.styles.input} checked={this.props.permiteUpdate?argsDocum.pagueHastaSegunSaldo:this.props.list.pagueHastaSegunSaldo} onChange={this.handleChange}/>
                  <label style={this.props.styles.label}>&nbsp;PAGO INMEDIATO si saldo mayor a X meses</label>
                  <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="numMesesParaPH" id="numMesesParaPH" placeholder='# de meses' value={this.props.permiteUpdate?argsDocum.numMesesParaPH:this.props.list.numMesesParaPH} onChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field>

            {/* <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Como asignar Ciclo de facturación a clientes</label>
                  <ListaCF styles={this.props.styles} list={this.props.list} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field> */}
            {/* <Form.Field>
              <div className="ui one column stackable grid">
                <div className="column" style={{width: '100%'}}>
                  <label style={this.props.styles.label}>Al Activar / Desactivar servicios mediante Ordenes de Servicio</label>
                  <ListaCC styles={this.props.styles} list={this.props.list} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                </div>
              </div>
            </Form.Field> */}

            <hr></hr>
            <h1 style={{color: 'yellow'}}>Empresa</h1>

            <Form.Field>
              <div className="ui two column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Razón social</label>
                  <input style={this.props.styles.input} autoComplete="off" name="empresaRazonSocial" id="empresaRazonSocial" value={this.props.permiteUpdate?argsDocum.empresaRazonSocial:this.props.list.empresaRazonSocial?this.props.list.empresaRazonSocial:""} onChange={this.handleChange} placeholder='Razón social'/>
                </div>
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>NIT</label>
                  <input style={this.props.styles.input} autoComplete="off" name="empresaNit" id="empresaNit" value={this.props.permiteUpdate?argsDocum.empresaNit:this.props.list.empresaNit?this.props.list.empresaNit:""} onChange={this.handleChange} placeholder='NIT'/>
                </div>
              </div>
            </Form.Field>
            <Form.Field>
              <div className="ui two column stackable grid">
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Dirección</label>
                  <input style={this.props.styles.input} autoComplete="off" name="empresaDir" id="empresaDir" value={this.props.permiteUpdate?argsDocum.empresaDir:this.props.list.empresaDir?this.props.list.empresaDir:""} onChange={this.handleChange} placeholder='Dirección'/>
                </div>
                <div className="column" style={{width: '50%'}}>
                  <label style={this.props.styles.label}>Teléfono(s)</label>
                  <input style={this.props.styles.input} autoComplete="off" name="empresaTel" id="empresaTel" value={this.props.permiteUpdate?argsDocum.empresaTel:this.props.list.empresaTel?this.props.list.empresaTel:""} onChange={this.handleChange} placeholder='Teléfono(s)'/>
                </div>
              </div>
            </Form.Field>
                  
            <hr></hr>

            <EstaSeguro permiteUpdate={this.props.permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </Form>
        </div>
      </div>
    )
  }
}

export default VerParam2
